export interface Category {
  slug: string;
  name: string;
  shortName: string;
  desc: string;
  icon: string;
  tint: "primary" | "accent" | "secondary";
}

export const categories: Category[] = [
  {
    slug: "variety",
    name: "综艺看点",
    shortName: "综艺",
    desc: "每周综艺名场面、赛制变化与嘉宾高光时刻的集中盘点。",
    icon: "ri-tv-2-line",
    tint: "primary",
  },
  {
    slug: "drama",
    name: "影视热剧",
    shortName: "影视",
    desc: "待播与在播剧集的选角思路、改编看点与追剧清单。",
    icon: "ri-film-line",
    tint: "accent",
  },
  {
    slug: "internet",
    name: "网络热点",
    shortName: "热点",
    desc: "全网热梗、二创与评论区文化的传播路径拆解。",
    icon: "ri-fire-line",
    tint: "primary",
  },
  {
    slug: "stars",
    name: "明星动态",
    shortName: "动态",
    desc: "艺人们的日常更新、舞台之外的内容选择与观众缘。",
    icon: "ri-star-line",
    tint: "secondary",
  },
  {
    slug: "live",
    name: "现场直击",
    shortName: "现场",
    desc: "音乐节、演出与舞台后台的真实节奏与现场观察。",
    icon: "ri-mic-line",
    tint: "accent",
  },
  {
    slug: "insight",
    name: "深度观察",
    shortName: "观察",
    desc: "注意力经济、内容趋势与文娱行业的冷静拆解。",
    icon: "ri-lightbulb-line",
    tint: "secondary",
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined =>
  categories.find((item) => item.slug === slug);